module.exports = __webpack_public_path__ + "media/images/ibjjf/bg-check-3-cb0249050224ee8ba1ca11b402b80bdc.svg";